import React from 'react';
import components from '../components';

const { code: Code } = components;

const renderCode = value => <Code code={value} disableWrapper />;

const processDataSummaryValue = (objPropValue, { isHtml }) => {
  let pValue = objPropValue;
  if (isHtml) {
    pValue = Array.isArray(objPropValue)
      ? objPropValue.map(({ keyField, [keyField]: value, ...otherProps }) => ({
          [keyField]: renderCode(value),
          keyField,
          ...otherProps
        }))
      : renderCode(objPropValue);
  }
  return pValue;
};

export default processDataSummaryValue;
